module.exports = "<p>search works!</p>\n"